module.exports = __webpack_public_path__ + "static/img/tabbt_2.891da71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tabbt_2.png
// module id = Y+j7
// module chunks = 1